import gql from 'graphql-tag';

const CREAR_UBICACION = gql`
  mutation createLocation($data: CreateLocationInput!) {
    createLocation(data: $data) {
      id
      tag
      isEnabled
      createdAt
      updatedAt
    }
  }
`;

export { CREAR_UBICACION };
